interface ToastMessage {
  variant: "default" | "destructive" | "information";
  description: string;
  duration?: number;
  closeOnClick?: boolean;
}

interface CampaignMessages {
  CREATE: {
    SUCCESS: ToastMessage;
    ERROR: ToastMessage;
  };
  UPDATE: {
    SUCCESS: ToastMessage;
    ERROR: ToastMessage;
  };
  INACTIVATE: {
    SUCCESS: ToastMessage;
    ERROR: ToastMessage;
  };
}

export const CAMPAIGN_MESSAGES: CampaignMessages = {
  CREATE: {
    SUCCESS: {
      variant: "default",
      description: "Campanha criada com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao criar campanha. Tente novamente.",
      duration: 5000,
      closeOnClick: true,
    },
  },
  UPDATE: {
    SUCCESS: {
      variant: "default",
      description: "Campanha atualizada com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao atualizar campanha. Tente novamente.",
      duration: 5000,
      closeOnClick: true,
    },
  },
  INACTIVATE: {
    SUCCESS: {
      variant: "default",
      description: "Campanha inativada com sucesso",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao inativar campanha",
      duration: 5000,
      closeOnClick: true,
    },
  },
};
